import { startOfDay, subDays } from "date-fns";

import { type ResolvedCancellationProtectionPayout } from "./types";
import { usePaginatedCancellationProtectionPayouts } from "./usePaginatedCancellationProtectionPayouts";

const PAYOUT_LOOKBACK_DAYS = 7;

interface UseLatestCancellationProtectionPayoutOptions {
  workerId: string;
  enabled?: boolean;
}

interface UseLatestCancellationProtectionPayoutResult {
  latestPayout: ResolvedCancellationProtectionPayout | undefined;
}

export function useLatestCancellationProtectionPayout(
  options: UseLatestCancellationProtectionPayoutOptions
): UseLatestCancellationProtectionPayoutResult {
  const { workerId, enabled = true } = options;

  const { data: payoutsData } = usePaginatedCancellationProtectionPayouts({
    params: {
      filter: {
        workerId: { eq: [workerId] },
        createdAt: { gte: [startOfDay(subDays(new Date(), PAYOUT_LOOKBACK_DAYS)).toISOString()] },
      },
      sort: ["-createdAt"],
      page: { size: 1 },
    },
    enabled,
  });

  return { latestPayout: payoutsData?.pages[0]?.[0] };
}
